<div class="line-card-section clickable-pointer" *ngIf="isClickable" uiSref="account.activity.details" [uiParams]="uiParams"
    [attr.aria-label]="ariaLabel" role="link" tabindex="0" (keydown)="onKeydown($event)">
    <div class="line-card" aria-hidden="true">
        <div class="name-icon" [style.backgroundColor]="lineCard.color"><span data-notranslate>{{ lineCard.iconLetter
                }}</span></div>
        <div class="display-name">
            <div [id]="lineCard.id.value" class="name" data-notranslate>{{ lineCard.displayName }}</div>
            <p class="line-status"
                *ngIf="(lineCard.isActive && !plan.isWatch) || (plan.isWatch && lineCard.isStandaloneWatch && enableStandaloneWatches)">
                {{ lineCard.lineNumber | phone }}</p>
            <p class="line-status"
                *ngIf="lineCard.isActive && plan.isWatch && pairedLineNumber && !lineCard.isStandaloneWatch">
                Paired with
                {{ pairedLineNumber | phone }}</p>
            <p class="line-status" *ngIf="!lineCard.isActive">{{ lineCard.displayStatus }}</p>
        </div>
        <p *ngIf="!plan.isWatch || (plan.isWatch && lineCard.isStandaloneWatch && enableStandaloneWatches)"
            class="line-data-usage">{{ lineDataUsage }} GB</p>
        <cms-text *ngIf="!plan.isWatch && pageData.managePlan" [originalText]="pageData.managePlan"
            [uiSref]="pageData.managePlanLink" [tabIndex]="-1" class="manage-plan"></cms-text>
    </div>
    <div class="data-bar" *ngIf="plan.isByTheGigShared || plan.isByTheGig" aria-hidden="true">
        <div class="progress" [style.backgroundColor]="lineCard.color" [style.width]="progressWidth"></div>
    </div>
</div>

<div class="line-card-section" *ngIf="!isClickable" [attr.aria-label]="ariaLabel">
    <div class="line-card">
        <div class="name-icon" [style.backgroundColor]="lineCard.color"><span data-notranslate>{{
                lineCard.iconLetter }}</span></div>
        <div class="display-name">
            <h1 [id]="lineCard.id.value" class="name" data-notranslate>{{ lineCard.displayName }}</h1>
            <p class="line-status" *ngIf="lineCard.isActive && !plan.isWatch">{{ lineCard.lineNumber | phone }}</p>
            <p class="line-status" *ngIf="lineCard.isActive && plan.isWatch && pairedLineNumber">Paired with {{
                pairedLineNumber | phone }}</p>
            <p class="line-status" *ngIf="plan.isWatch && !pairedLineNumber">{{ pageData.inactiveWatchInfo }}</p>
            <p class="line-status" *ngIf="!lineCard.isActive">{{ lineCard.displayStatus }}</p>
        </div>
        <p *ngIf="!plan.isWatch" role="region" [attr.aria-labelledby]="lineCard.id.value" class="line-data-usage">{{
            lineDataUsage }} GB
        </p>
        <cms-text *ngIf="!plan.isWatch && pageData.managePlan" [originalText]="pageData.managePlan"
            [uiSref]="pageData.managePlanLink" class="manage-plan"
            [attr.aria-label]="pageData.managePlanLink + ' for ' + lineCard.displayName"></cms-text>
    </div>
    <div class="data-bar" *ngIf="plan.isByTheGigShared || plan.isByTheGig">
        <div class="progress" [style.backgroundColor]="lineCard.color" [style.width]="progressWidth"></div>
    </div>
</div>
